import { useEffect } from "react";
import { useGames } from "./firebase";
import { Box, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Overview = () => {
    const navigate = useNavigate();
    const games = useGames();

    useEffect(() => {
        document.title = "QwickHub";
    }, []);

    if (games === undefined) return <div>Loading</div>;

    return (
        <Box sx={{ width: "100%", maxWidth: 360 }}>
            <List>
                {games.map(game => (
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => {
                                navigate(`/games/${game.id}`);
                            }}>
                            <ListItemText primary={game.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default Overview;
